import {useEffect, useState} from 'react';
import {useSearchParams} from "react-router-dom";

const getSearchView = () => {
    const params = new URLSearchParams(window.location.search);
    return params.has('view') ? params.get('view') : '';
}
const getSearchFilters = () => {
    const params = new URLSearchParams(window.location.search);
    return params.has('filters') ? params.get('filters') : '';
}

const useSearchView = () => {
    const [search, setSearch] = useSearchParams();
    const [searchView, setSearchView] = useState(getSearchView());
    const [searchFilters, setSearchFilters] = useState(getSearchFilters());

    const setView = (view: string) => {
        const params = new URLSearchParams(window.location.search);
        params.set('view', view);
        setSearch(params.toString());
    };

    const setFilters = (filters?: string | null) => {
        const params = new URLSearchParams(window.location.search);
        if(filters && filters !== ''){
            params.set('filters', filters);
        }else{
            params.delete('filters');
        }
        setSearch(params.toString());
    };

    useEffect(() => {
        setSearchView(getSearchView());
        setSearchFilters(getSearchFilters());
    }, [search]);

    return { view: searchView, filters: searchFilters, setView, setFilters };
}

export default useSearchView;